import React, {  } from "react";
import { InputBaseProps } from "..";
import { SanityInputTextProps } from "../../../models/form/SanityFormInputField";
import GenericTextInput from "./GenericTextInput";

export type TextProps = InputBaseProps<SanityInputTextProps>;

const Text = (props: TextProps) => 
    <GenericTextInput 
        {...props}
        type={"text"}
    />;

export default Text;
